import { ECompanyTypeIdConst } from '@company/companyType/companyType.constants';
import { AppConfigContext } from '@config/AppConfig';
import { ERolePermission, ESiteTransmittalPermission } from '@userProfile/permission/permission.constants';
import { useHasPermission } from '@config/config.hooks';
import { IMasterScheduleDetail } from '@masterSchedule/detail/masterScheduleDetail.models';
import { useNominatedInMasterSchedule } from '@masterSchedule/masterSchedule.hooks';
import { hasPermissionInArray } from '@userProfile/permission/permission.services';
import { useContext } from 'react';

export const useAllowNewIceT = () => {
  const appConfigs = useContext(AppConfigContext);
  return hasPermissionInArray(
    appConfigs.configs.myPermissions,
    ESiteTransmittalPermission.PREPARE_APPROVAL,
    ECompanyTypeIdConst.CHECKER,
  );
};
export const useAllowNewIceTWithT1 = (masterScheduleIsCancelled: boolean, masterScheduleType: string) => {
  const isPermitted = useAllowNewIceT();
  // TODO check master schedule type
  if (masterScheduleIsCancelled || masterScheduleType === 'D') return false;
  return isPermitted;
};

export const useAllowEndorseIceT = (masterSchedule?: IMasterScheduleDetail) => {
  const isPermitted = useHasPermission(ERolePermission.ICE_AUTHORISED_REPRESENTATIVE);
  const { isNominatedChecker } = useNominatedInMasterSchedule(masterSchedule);
  return isNominatedChecker && isPermitted;
};
